import { c as _c } from "react/compiler-runtime";
import type { LabelKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useLabelText = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "headerDefault.fraudLabel.labels"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = label => {
      if (label === "active") {
        return t(_temp);
      }
      if (label === "offboard_fraud") {
        return t(_temp2);
      }
      if (label === "offboard_other") {
        return t(_temp3);
      }
      return "";
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useLabelText;
function _temp($) {
  return $.active;
}
function _temp2($_0) {
  return $_0.offboardFraud;
}
function _temp3($_1) {
  return $_1.offboardOther;
}